import { createContext } from 'react';

export interface EnvironmentContextValue {
    selectedEnvironment: string;
    setSelectedEnvironment: (environment: string) => void;
}

export const EnvironmentContext = createContext<EnvironmentContextValue | undefined>(undefined);
